import React from 'react';
import PropTypes from 'prop-types';

const User = ({ size, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 88 88"
  >
    <rect width="88" height="88" fill="#E6F3FD" rx="44"></rect>
    <rect width="72" height="72" x="8" y="8" fill="#E6F3FD" rx="36"></rect>
    <path
      stroke="#0189ED"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m40.578 48.6-1.123 4.492-7.086 1.574A1.82 1.82 0 0 0 31 56.001l-.654 2.614M47.424 48.6l1.122 4.492 7.085 1.574c.673.15 1.202.666 1.37 1.335l.654 2.614"
    ></path>
    <path
      stroke="#0189ED"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M51.272 40.364a7.273 7.273 0 0 0-14.545 0v1.818a7.273 7.273 0 1 0 14.545 0z"
    ></path>
    <path
      stroke="#0189ED"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M44 64c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
    ></path>
  </svg>
);

User.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

User.defaultProps = {
  size: 88,
  className: '',
};

export default User;
